import { Alert, cn } from "@kyan/ui";
import { v5 as uuidv5 } from "uuid";

import { UUID_NAMESPACE } from "#/config/definitions";

import { useRemoteNoticeController } from "./RemoteNotice.controller";

export const RemoteNotice = ({ className }: { className?: string }) => {
  const { alerts } = useRemoteNoticeController();

  if (!alerts.length) return null;

  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {alerts.map((alert) => (
        <Alert
          className="p-4"
          title={alert.title}
          variant={alert.variant}
          description={alert.description}
          key={uuidv5(alert.title, UUID_NAMESPACE)}
          actionProps={
            alert.action
              ? {
                  size: "md",
                  children: alert.action,
                  variant: "alternative",
                  className: "text-sm w-26",
                  onClick: alert.onClick,
                }
              : undefined
          }
        />
      ))}
    </div>
  );
};
